const leaf = "M0 0 C7 -8 19 -8 28 0 C19 8 7 8 0 0 Z M0 0 L24 0";

const Leaf = ({ x, y, r, s = 1 }) => (
  <path d={leaf} transform={`translate(${x} ${y}) rotate(${r}) scale(${s})`} />
);

export const Sprig = ({ className = "" }) => (
  <svg className={`ornament ${className}`} viewBox="0 0 120 220" aria-hidden="true">
    <g fill="none" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round">
      <path d="M62 216 C58 170 64 128 58 84 C55 58 60 30 70 6" />
      <Leaf x={60} y={182} r={-150} />
      <Leaf x={61} y={160} r={-28} />
      <Leaf x={60} y={136} r={-155} s={0.95} />
      <Leaf x={60} y={114} r={-32} s={0.9} />
      <Leaf x={58} y={92} r={-160} s={0.85} />
      <Leaf x={58} y={70} r={-38} s={0.8} />
      <Leaf x={61} y={46} r={-150} s={0.7} />
      <Leaf x={66} y={24} r={-50} s={0.6} />
    </g>
  </svg>
);

const birchLeaf = "M0 0 C-6 -4 -7 -12 0 -18 C7 -12 6 -4 0 0 Z M0 0 L0 -15";

export const BirchTwig = ({ className = "" }) => (
  <svg className={`ornament ${className}`} viewBox="0 0 240 110" aria-hidden="true">
    <g fill="none" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 60 C50 52 92 58 136 46 C170 37 204 40 236 30" />
      <path d="M70 56 C80 72 92 80 104 86" />
      <path d="M150 43 C156 28 166 18 178 12" />
      {[[30, 57, 200], [56, 55, 160], [104, 86, 140], [92, 78, 210], [120, 51, 25], [178, 12, 60], [166, 20, -20], [206, 38, 160], [226, 32, 20]].map(([x, y, r]) => (
        <path key={`${x}-${y}`} d={birchLeaf} transform={`translate(${x} ${y}) rotate(${r})`} />
      ))}
      <path d="M140 46 C141 58 140 68 137 78" strokeDasharray="1.5 3" strokeWidth="2.2" />
      <path d="M196 38 C198 50 197 58 194 66" strokeDasharray="1.5 3" strokeWidth="2.2" />
    </g>
  </svg>
);

const Daisy = ({ x, y, s = 1 }) => (
  <g transform={`translate(${x} ${y}) scale(${s})`}>
    {[0, 45, 90, 135, 180, 225, 270, 315].map((r) => (
      <ellipse key={r} cx="0" cy="-9" rx="3.2" ry="7" transform={`rotate(${r})`} />
    ))}
    <circle r="3.2" />
  </g>
);

export const Wildflowers = ({ className = "" }) => (
  <svg className={`ornament ${className}`} viewBox="0 0 160 200" aria-hidden="true">
    <g fill="none" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round">
      <path d="M60 198 C58 150 50 110 44 62" />
      <path d="M78 198 C84 150 96 118 112 84" />
      <path d="M70 198 C72 170 70 150 76 128" />
      <Daisy x={44} y={52} />
      <Daisy x={113} y={74} s={0.8} />
      <path d="M76 128 C72 120 72 112 76 104 C80 112 80 120 76 128 Z" />
      <path d="M76 116 C68 110 66 102 68 96 M76 116 C84 110 86 102 84 96" />
      <Leaf x={52} y={150} r={-140} s={0.8} />
      <Leaf x={86} y={160} r={-40} s={0.8} />
      <Leaf x={58} y={118} r={-20} s={0.6} />
    </g>
  </svg>
);

export const HeartDivider = ({ className = "" }) => (
  <svg className={`heart-divider ${className}`} viewBox="0 0 220 20" aria-hidden="true">
    <g stroke="currentColor" strokeWidth="1" strokeLinecap="round" fill="none">
      <path d="M2 10 H92" />
      <path d="M128 10 H218" />
    </g>
    <path d="M110 17 C100 10 96 6 98 3.5 C100 1 104 1.5 110 6 C116 1.5 120 1 122 3.5 C124 6 120 10 110 17 Z" fill="currentColor" />
  </svg>
);

export const Divider = ({ className = "" }) => (
  <svg className={`divider ${className}`} viewBox="0 0 220 24" aria-hidden="true">
    <g fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round">
      <path d="M2 12 H86" />
      <path d="M134 12 H218" />
      <path d="M110 12 C102 4 92 4 88 12 C92 20 102 20 110 12 Z" />
      <path d="M110 12 C118 4 128 4 132 12 C128 20 118 20 110 12 Z" />
      <circle cx="110" cy="12" r="1.6" fill="currentColor" />
    </g>
  </svg>
);
